<template>
    <the-content>
        <div class="heading">
            <div class="heading-nav">
                <v-btn :to="{name: 'clients.list'}" text fab small>
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
            </div>
            <h1 class="heading-title">Настройки</h1>
        </div>

        <settings-profile/>
        <settings-time/>
        <settings-bots/>
    </the-content>
</template>

<script>
    import SettingsBots from "../components/SettingsBots";
    import SettingsTime from "../components/SettingsTime";
    import SettingsProfile from "../components/SettingsProfile";

    export default {
        name      : "SettingsPage",
        components: {SettingsProfile, SettingsTime, SettingsBots},
    }
</script>

<style lang="scss">

    .setting-block {
        + .setting-block {
            margin-top: 60px;
        }
    }
</style>
